export default {
  searchId: 'advanced_search',
  title: 'Ricerca avanzata',
  resourcePath: '/obra',
  totalResultsText: 'advancedsearch#works_total',
  grid: 1,
  filters: {
    title: 'advancedsearch#filters_title',
    labels: {
      'resource-type': 'advancedsearch#label_resource_type',
      'query-fulltext': 'advancedsearch#fulltext_text',
      'query-title': 'advancedsearch#label_title',
      'query-content': 'advancedsearch#label_content',
      'query-edition': 'advancedsearch#library_text',
      'query-source': 'advancedsearch#label_signature',
      bibl_opera_autore: 'advancedsearch#label_bibl_opera_autore',
      bibl_opera_traduttore: 'advancedsearch#label_bibl_opera_traduttore',
      query: 'advancedsearch#label_title',
      work_language: 'advancedsearch#label_language',
      work_cycle: 'advancedsearch#label_cycle',
      work_subject: 'advancedsearch#label_subject',
      'query-place': 'advancedsearch#label_place',
      'query-editor': 'advancedsearch#label_editor',
      'query-dedica': 'advancedsearch#label_dedicatario',
      'query-editorial-mark': 'advancedsearch#label_marca',
      marginalia: 'advancedsearch#marginalia_label',
      'query-library_city': 'advancedsearch#label_library_city',
      'query-library': 'advancedsearch#label_library',
      'query-previous_owner': 'advancedsearch#label_previous_owner',
      reproduction: 'advancedsearch#reproduction_label',
      'query-note': 'advancedsearch#label_note',
      digital_edition: 'advancedsearch#digital_edition_label'
      // 'query-text': 'advancedsearch#label_text',
      // 'query-distance-text': 'advancedsearch#label_distance',
      // 'query-bibl': 'advancedsearch#label_bibl',
      // author: 'advancedsearch#label_author',
      // censors: 'advancedsearch#label_censors',
      // signature: 'advancedsearch#label_signature',
      // year: 'advancedsearch#label_date',
    }
  },
  sort: {
    label: 'search#sort_title',
    options: [

      // {
      //   value: 'section_ASC',
      //   label: 'search#sort_section_asc',
      //   selected: true
      // },
      // {
      //   value: 'section_DESC',
      //   label: 'search#sort_section_desc',
      //   selected: true
      // },
      {
        value: '_score',
        label: 'search#sort_score',
        selected: true,
      },
      {
        value: 'title_ASC',
        label: 'search#sort_asc',
        selected: false
      },
      {
        value: 'title_DESC',
        label: 'search#sort_desc',
        selected: false
      },
    ]
  },
  pagination: {
    selectLabel: 'search#results_number',
    limit: 5,
    options: [
      12,
      24,
      48
    ]
  },
  itemPreview: {
    linkTarget: '_self',
    // classes: 'is-vertical'
  },
  fallback: {
    text: 'search#fallback_text',
    button: 'search#fallback_button',
    payload: {
      action: 'redirect',
      url: '/advanced-search',
    },
  },
  ko: {
    text: 'search#ko_text',
    button: 'search#ko_button'
  }
};
